/*
  Pitchers Only — Homepage Arkive/Mystery slideshow wrapper.
  Finds the existing collection-feature (cf-) and mystery-story (ms-) sections
  on the homepage and turns them into an auto-cycling 2-slide carousel.
  The original section markup and styling stay untouched.
*/
(function () {
  if (document.body.dataset.poHpSlideshowInit === '1') return;

  function init() {
    const cf = document.querySelector('section.cf, section[id^="cf-"]');
    const ms = document.querySelector('section[id^="ms-"]');
    if (!cf || !ms) return;
    const cfWrap = cf.closest('.shopify-section');
    const msWrap = ms.closest('.shopify-section');
    if (!cfWrap || !msWrap) return;
    // Only wire up if they're adjacent in DOM (post-restore order).
    if (cfWrap.nextElementSibling !== msWrap) return;

    document.body.dataset.poHpSlideshowInit = '1';

    const container = document.createElement('div');
    container.className = 'po-hp-slideshow';
    container.setAttribute('role', 'region');
    container.setAttribute('aria-roledescription', 'carousel');
    container.setAttribute('aria-label', 'Featured collections');

    cfWrap.parentNode.insertBefore(container, cfWrap);
    container.appendChild(cfWrap);
    container.appendChild(msWrap);

    const slides = [cfWrap, msWrap];
    slides.forEach((s, i) => {
      s.classList.add('po-hp-slide');
      s.setAttribute('role', 'group');
      s.setAttribute('aria-roledescription', 'slide');
      s.setAttribute('aria-label', (i + 1) + ' of ' + slides.length);
    });

    // Dots
    const dots = document.createElement('div');
    dots.className = 'po-hp-dots';
    dots.setAttribute('role', 'tablist');
    const dotButtons = slides.map((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'po-hp-dot';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      b.addEventListener('click', () => go(i, true));
      dots.appendChild(b);
      return b;
    });
    container.appendChild(dots);

    let active = 0;
    let timer = null;
    const CYCLE_MS = 6000;

    function go(i, manual) {
      active = (i + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle('po-hp-slide--active', idx === active));
      dotButtons.forEach((b, idx) => {
        b.classList.toggle('po-hp-dot--active', idx === active);
        b.setAttribute('aria-selected', idx === active ? 'true' : 'false');
      });
      // Resize container to active slide height for smooth fade.
      const h = slides[active].getBoundingClientRect().height;
      container.style.minHeight = Math.ceil(h) + 'px';
      if (manual) restart();
    }

    function restart() {
      clearInterval(timer);
      timer = setInterval(() => go(active + 1, false), CYCLE_MS);
    }

    go(0, false);
    restart();

    // Pause on hover/focus.
    container.addEventListener('mouseenter', () => clearInterval(timer));
    container.addEventListener('mouseleave', restart);
    container.addEventListener('focusin', () => clearInterval(timer));
    container.addEventListener('focusout', restart);

    // Touch swipe (mobile). 50px horizontal threshold; ignore vertical-dominant gestures.
    let touchStartX = 0;
    let touchStartY = 0;
    container.addEventListener('touchstart', (e) => {
      const t = e.changedTouches[0];
      touchStartX = t.clientX;
      touchStartY = t.clientY;
      clearInterval(timer);
    }, { passive: true });
    container.addEventListener('touchend', (e) => {
      const t = e.changedTouches[0];
      const dx = t.clientX - touchStartX;
      const dy = t.clientY - touchStartY;
      if (Math.abs(dx) >= 50 && Math.abs(dx) > Math.abs(dy)) {
        go(active + (dx < 0 ? 1 : -1), true);
      } else {
        restart();
      }
    }, { passive: true });

    // Keep container height correct on resize.
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(() => {
        const h = slides[active].getBoundingClientRect().height;
        container.style.minHeight = Math.ceil(h) + 'px';
      });
      slides.forEach(s => ro.observe(s));
    } else {
      window.addEventListener('resize', () => {
        const h = slides[active].getBoundingClientRect().height;
        container.style.minHeight = Math.ceil(h) + 'px';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
